<template>
  <div class="wisdom-store">
    <div class="store-content padding-main mobile-padding">
      <el-row>
        <el-col :xs="24"
                :sm="24"
                :md="8"
                class="store-desc">
          <div class="store-title">{{ $t('wisdomStore.wisdomStore') }}</div>
          <div class="store-tip">{{ $t('wisdomStore.wisdomStoreTip1') }}<span>{{ $t('wisdomStore.wisdomStoreTip2') }}</span></div>
          <!-- <div class="store-tip-blue hidden-sm-and-down">{{ $t('wisdomStore.wisdomStoreTip2') }}</div> -->
        </el-col>
        <el-col :xs="24"
                :sm="24"
                :md="16"
                style="text-align: right;">
          <div class="image-flex">
            <el-image class="store-image"
                      src="/img/wisdom_store.png"
                      fit="cover" />
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="store-list padding-main mobile-padding">
      <div class="list-name">{{ $t('wisdomStore.features') }}</div>
      <div class="list">
        <div v-for="(item ,index) in featuresList"
             :key="index"
             class="list-item">
          <el-image :src="vaildatePc()?item.icon:item.mobile_icon"
                    fit="cover" />
          <div class="item-name">{{ item.name }}</div>
          <div class="item-content">{{ item.describe }}</div>
        </div>
        <div class="list-item list-last hidden-sm-and-down">
          features
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { wisdomStoreObj } from '@/const/crud/list'
import { vaildatePc } from '@/commonModule/utils/validate'

export default {
  name: 'WisdomStore',
  data () {
    return {
      vaildatePc,
      featuresList: wisdomStoreObj.featuresList
    }
  },
  methods: {
  }

}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixin.scss';

.image-flex {
  height: 100%;
  @include wrap-flex;
}

.el-row,
.el-col {
  height: 100%;
}

.wisdom-store {
  .store-content {
    background-color: $bgColor;
    height: 39.06vw;
    .store-title {
      font-size: 42px;
      margin-top: 7.29vw;
      font-weight: bold;
      color: #3f3e3e;
      margin-bottom: 0.72vw;
    }
    .store-tip {
      font-size: 18px;
      margin-bottom: 0.72vw;
    }
    .store-tip-blue {
      background-color: $mainColor;
      font-size: 18px;
      padding: 0 0.83vw;
      width: fit-content;
      color: #fff;
    }
  }
  .store-list {
    .list-name {
      text-align: center;
      font-size: 26px;
      font-weight: bold;
      margin-bottom: 1.56vw;
    }
    .list {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      .list-item {
        padding: 1.56vw;
        width: 30.46vw;
        height: 14.58vw;
        margin-bottom: 1.56vw;
        text-align: center;
        border: 1px solid #f7fcfe;
        box-shadow: 0 10px 20px 6px rgba(228, 228, 228, 0.5);
        &:nth-child(2n-1) {
          margin-right: 1.56vw;
        }
        .el-image {
          width: 4.58vw;
        }
        .item-name {
          font-size: 1.25vw;
          font-weight: bold;
          margin-top: 1.04vw;
          margin-bottom: 0.72vw;
        }
        .item-content {
          font-size: 16px;
        }
        &.list-last {
          font-size: 32px;
          color: #ccc;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}

@media screen and (min-width: 992px) and (max-width: 1350px) {
  .store-list {
    .item-content {
      font-size: 12px !important;
    }
  }
}

@media screen and (min-width: 1350px) and (max-width: 1500px) {
  .store-list {
    .item-content {
      font-size: 14px !important;
    }
  }
}

@media screen and (max-width: 992px) {
  .el-col {
    height: auto;
  }
  .mobile-padding {
    height: auto !important;
    padding: 5.33vw $mobilePadding !important;
  }
  .wisdom-store {
    .store-content {
      height: 106.67vw !important;
      padding: 5.33vw 0 !important;
      text-align: center;
      .store-desc {
        padding: 0 $mobilePadding;
        .store-title {
          font-size: 4.27vw;
          margin-bottom: 1.33vw;
          font-size: bold;
        }
        .store-tip {
          font-size: $mobileFontSize;
          margin-bottom: 11.2vw;
          // span {
          //   color: $mainColor;
          // }
        }
      }
    }
    .store-list {
      padding: 1.875vw 0;
      .list-name {
        font-size: 4.27vw;
      }
      .list {
        display: block;
        .list-item {
          padding: 5.33vw 0;
          width: 100%;
          height: auto;
          border: none;
          box-shadow: none;
          .el-image {
            width: 14.4vw;
            margin-bottom: 3.73vw;
          }
          .item-name {
            font-size: 4.27vw;
            margin-top: 0vw;
            margin-bottom: 1.33vw;
          }
          .item-content {
            font-size: $mobileFontSize;
          }
        }
      }
    }
  }
}
</style>
